// extracted by mini-css-extract-plugin
export default {"title":"_3xzkc","description":"_2Widi"};